<script lang="ts">
    export let value: number | undefined | null
    export let total: number | undefined | null
    export let text: string

    export let colorPri: string
    export let colorSec: string
</script>

<div class="pt-3 text-center">
    <div class="w-full flex flex-row justify-between">
        <span class="font-bold">{value?.toFixed(1) ?? '-'}</span>
        <span class="font-bold ml-auto">{total?.toFixed(1) ?? '-'}</span>
    </div>
    {#if !!value && !!total}
        {@const pcnt = (value / total) * 100}
        <div
            class="w-full min-h-[22px] max-h-[22px]"
            style={`background: linear-gradient(to right, ${colorPri}, ${colorPri} ${pcnt}% , ${colorSec} ${pcnt}%, ${colorSec});`} 
        />
    {:else}
        <div class="w-full min-h-[22px] max-h-[22px] bg-gray-400" />
    {/if}
    <h6 class="my-2 text-sm">{text}</h6>
</div>
